type OptionProps = {
    day: '2-digit' | 'numeric' | undefined
    month: '2-digit' | 'numeric' | 'short' | 'long' | 'narrow' | undefined
    year: '2-digit' | 'numeric' | undefined
    hour?: '2-digit' | 'numeric'
    minute?: '2-digit' | 'numeric'
    second?: '2-digit' | 'numeric'
}

function isUnixTimestamp(value: number): boolean {
    const hasValidLength = value.toString().length === 10 || value.toString().length === 11
    if (hasValidLength) {
        const convertedDate = new Date(value * 1000)
        const year = convertedDate.getUTCFullYear()
        if (year >= 1970 && year <= 2100) return true
    }
    return false
}

export function formatDate(val: string | number | Date, withTime?: boolean) {
    if ((typeof val === 'number' || typeof val === 'string') && isUnixTimestamp(val as number)) {
        val = Number(val) * 1000
    }

    const options: OptionProps = { day: '2-digit', month: 'short', year: 'numeric' }

    if (withTime) {
        options.hour = '2-digit'
        options.minute = '2-digit'
        options.second = '2-digit'
    }

    const date = new Date(val)
    return date && date.toLocaleDateString('en-AU', options)
}
